import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { TextType } from '@amzn/meridian/text/text';
import styled from '@emotion/styled';
import React, { FC } from 'react';

const Link = styled.div`
    cursor: pointer;
`;
const LinkText = styled(Text)`
    color: #0047ab;
`;
type ReferenceCellProps = {
    translatedText: string;
    fileId: string;
    callback: Function;
    heading?: TextType;
};

export const ClaimReferenceCell: FC<ReferenceCellProps> = ({
    translatedText,
    fileId,
    callback,
    heading = 'b300',
}: ReferenceCellProps) => {
    return (
        <Row width={'100%'}>
            <Link onClick={() => callback(fileId)}>
                <LinkText type={heading}>{translatedText}</LinkText>
            </Link>
        </Row>
    );
};
